import api from "./core";

const basePath = "api/core/Documents";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  getDetailed(id) {
    return api.get(`${basePath}/GetDetailed/${id}`);
  },
  getDetailedImproved(id) {
    return api.get(`${basePath}/GetDetailedImproved/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  updateAndComplete(id, data) {
    return api.patch(`${basePath}/${id}/SaveAndComplete`, data);
  },
  revert(id) {
    return api.patch(`${basePath}/${id}/RevertComplete`);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(formId, clientId, eocId) {
    return api.post(`${basePath}/ByEoc/${formId}/${eocId}`);
  },
  queryByCateg(category, clientId, eocId) {
    return api.post(`${basePath}/ByEocAndCategory/${category}/${eocId}`);
  },
  queryByCategInTreatmentPlan(category, clientId, eocId) {
    return api.post(
      `${basePath}/ByEocAndCategoryInTreatmentPlan/${category}/${eocId}`
    );
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  createAndComplete(data) {
    return api.put(`${basePath}/CreateAndComplete`, data);
  },
  upload(data) {
    const { file, clientId, formId, date, eocId, submitId, status } = data;
    const formData = new FormData();
    formData.append("File", file);
    formData.append("PatientId", clientId);
    formData.append("FormId", formId);
    formData.append("EffectiveDate", date);
    formData.append("EpisodeOfCareId", eocId);
    formData.append("Status", status);
    if (submitId) formData.append("id", submitId);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.put(`${basePath}/upload`, formData, config);
  },
  uploadUpdate(data) {
    const { file, date, submitId, status, formId } = data;
    const formData = new FormData();
    if (file) formData.append("File", file);
    formData.append("EffectiveDate", date);
    formData.append("Status", status);
    formData.append("FormId", formId);
    if (submitId) formData.append("id", submitId);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.patch(`${basePath}/upload`, formData, config);
  },
  viewUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/Download/${api.getToken()}/${id}`;
  },
  setScore(id, data) {
    return api.patch(`${basePath}/SetScore/${id}`, data);
  }
};
